import type { ReactElement } from 'react';
import styles from './ModalCloseButton.module.scss';

export function ModalCloseButton(props: { onClick: () => void }): ReactElement {
  return (
    <button type="button" className={styles.close} onClick={props.onClick}>
      ×
    </button>
  );
}
